import i18n from 'i18next';
import {Text} from 'platform/foundation';
import {useDateTimeFormatter, useFormatNumber} from 'platform/locale';

import {parseDate} from 'shared/web';

import type {BulkOperationResponseBody} from '../../types/api/bulkOperations';
import type {BulkOperationPresentation} from '../../types/BulkOperationPresentation';

type BulkOperationSubtitleProps = {
  operation: Pick<BulkOperationResponseBody, 'resourceId' | 'totalCount' | 'createdAt'>;
  size?: 'small' | 'xSmall';
  presentation?: BulkOperationPresentation;
};

export function BulkOperationSubtitle(props: BulkOperationSubtitleProps) {
  const formatDateTime = useDateTimeFormatter();
  const formatNumber = useFormatNumber();
  const operation = props.operation;
  const scopeLabel =
    props.presentation?.getCountLabel?.(
      operation.resourceId,
      operation.totalCount,
      formatNumber(operation.totalCount, 0)
    ) ??
    i18n.t('page.datagrid.bulkOperations.panel.recordCount', {
      count: operation.totalCount,
      replace: {count: formatNumber(operation.totalCount, 0)},
      defaultValue: operation.totalCount === 1 ? '{count} record' : '{count} records',
    });
  const startedLabel = i18n.t('page.datagrid.bulkOperations.panel.startedAgo', {
    time: formatDateTime('dateRelative', parseDate(operation.createdAt)),
    defaultValue: 'Started {time}',
  });

  return (
    <Text size={props.size ?? 'small'} color="secondary">
      {scopeLabel} · {startedLabel}
    </Text>
  );
}
